import { gql } from 'graphql-request';

export const SEPHORA_PRODUCTS = gql`
  query GetSephoraProducts {
    collection(handle: "pro-bond-repair") {
      handle
      products(first: 25) {
        edges {
          node {
            id
            title
            handle
            tags
            availableForSale
            variants(first: 5) {
              edges {
                node {
                  id
                  availableForSale
                }
              }
            }
            priceRange {
              maxVariantPrice {
                amount
              }
            }
            featuredImage {
              url
            }
          }
        }
      }
    }
  }
`;
